module.exports = __webpack_public_path__ + "img/pt-20.1fd7f5bd.svg";